import React, { useState } from 'react';
import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Image,
  Input,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FiKey } from 'react-icons/fi';
import { RecoveryPasswordForm, useRecoveryPasswordForm } from './hooks/useRecoveryPasswordForm';
import { RecoveryPasswordModal } from './components/RecoveryPasswordModal';
import api from '../../services/api';
import { Link } from 'react-router-dom';

export const PasswordRecovery = () => {
  const { controls, handleSubmit, errors, getValues } = useRecoveryPasswordForm();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [isSuccess, setIsSuccess] = useState<boolean>(true);

  const submit = async (data: RecoveryPasswordForm) => {
    try {
      const res = await api.put<void>('/password-recovery', data);
      setIsSuccess(res.status === 201);
    } catch (_) {
      setIsSuccess(false);
    } finally {
      onOpen();
    }
  };

  return (
    <Center height="100vh">
      <RecoveryPasswordModal isOpen={isOpen} onClose={onClose} isSuccess={isSuccess} email={getValues('email')} />
      <Stack>
        <Image src="/logo@2x.png" alt="logo" width="6em" marginBottom="xl" />
        <Stack padding="xxl" borderRadius="xl" border="1px" borderColor="gray.300" maxWidth="25em">
          <Center marginY="xl">
            <Box borderRadius="full" padding="l" backgroundColor="primary.800" width="fit-content">
              <FiKey fontSize="1.5em" color="white" />
            </Box>
          </Center>
          <Heading as="h1" fontSize="xxl" fontWeight="bold" marginBottom="xl">¿Olvidaste tu contraseña?</Heading>
          <Text>No te preocupes, ingresa tu email asociado para poder generar una nueva.</Text>

          <FormControl isInvalid={!!errors.email}>
            <FormLabel marginTop="xl">Email</FormLabel>
            <Input type="text" {...controls.email} />
            <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
          </FormControl>

          <Flex justifyContent="space-between" alignItems="center" marginTop="xl">
            <Link to="/login">
              <Button variant="ghost" colorScheme="primary">Volver</Button>
            </Link>
            <Button colorScheme="button-primary" onClick={handleSubmit(submit)}>Enviar recupero</Button>
          </Flex>
        </Stack>
      </Stack>
    </Center>
  );
};
